import { API_BASE_URL, performTokenRefresh } from "@repo/api";
import type { HostConfig } from "./hostConfig";

export interface AgentHostConfig extends HostConfig {}

interface PermissionParams {
  isReadOnly?: boolean;
  permissions?: string[];
  userRole?: string;
  license?: HostConfig["license"];
}

const isDev = import.meta.env.DEV;

export function getAgentHostConfig(
  onNavigate?: (path: string) => void,
  permissionParams?: PermissionParams,
): AgentHostConfig {
  const apiBaseUrl = isDev
    ? `${window.location.origin}/api-proxy`
    : (import.meta.env.VITE_API_BASE_URL as string) || window.location.origin;

  return {
    basename: "/agents",
    apiBaseUrl,
    hostName: "standalone-ui",
    onUnauthorized: () => performTokenRefresh(API_BASE_URL),
    onNavigate,
    ...permissionParams,
  };
}
